import api from "@/api";
const LIMIT = 12; // must be multiple of 2 and 3

let previousPromotionDepartmentId = 0;
let end = false;
let page = 1;

/*
const nabNeededProps = (product) => {
  const {
    categories,
    cents,
    full_data,
    is_alcohol,
    is_tobacco,
    name,
    parent_categories,
    tobacco_warning,
    upc,
  } = product;

  const { base_size, brand, qty, size, uom } = full_data;

  return {
    base_size,
    brand,
    categories,
    cents,
    is_alcohol,
    is_tobacco,
    name,
    parent_categories,
    qty,
    size,
    tobacco_warning,
    uom,
    upc,
  };
};

const construct = (products) => products.map(nabNeededProps);
*/

const state = () => ({
  order: { display: "Alphabetical", value: "alphabetical" },
  data: { products: [] },
  pending: false,
});

const actions = {
  async fetch({ commit, dispatch, state }, promotionDepartmentId) {
    const newDepartment =
      previousPromotionDepartmentId !== promotionDepartmentId;

    if (newDepartment) {
      end = false;
      page = 1;
      previousPromotionDepartmentId = promotionDepartmentId;
      commit("RESET_PRODUCTS");
      commit("PENDING", true);
    } else {
      if (end) {
        return;
      }
    }
    let params;

    if (state.order.value === "popularity") {
      params = { order: "popularity", direction: "desc" };
    } else {
      params = { order: "name", direction: "asc" };
    }

    const data = await api({
      params: {
        limit: LIMIT,
        page,
        sortby: params.order,
        sortdir: params.direction,
      },
      url: `/123/promotions/${promotionDepartmentId}`,
    });

    commit("PENDING", false);

    data.err
      ? dispatch("error/showError", data.err, { root: true })
      : commit("UPDATE", data.info);
  },
  async restartFetch({ commit, dispatch, state }, promotionDepartmentId) {
    end = false;
    page = 1;
    previousPromotionDepartmentId = promotionDepartmentId;
    commit("RESET_PRODUCTS");
    commit("PENDING", true);

    let params;

    if (state.order.value === "popularity") {
      params = { order: "popularity", direction: "desc" };
    } else {
      params = { order: "name", direction: "asc" };
    }

    const data = await api({
      params: {
        limit: LIMIT,
        page,
        sortby: params.order,
        sortdir: params.direction,
      },
      url: `/123/promotions/${promotionDepartmentId}`,
    });

    commit("PENDING", false);
    data.err
      ? dispatch("error/showError", data.err, { root: true })
      : commit("UPDATE", data.info);
  },
};

const getters = {
  loaded({ pending }) {
    return !pending;
  },
};

const mutations = {
  CHANGE_SORT_ORDER(state, order) {
    state.order = order;
  },
  PENDING(state, pending) {
    state.pending = pending;
  },
  RESET_PRODUCTS(state) {
    state.data.products = [];
  },
  UPDATE(state, promotion) {
    if (!promotion.products.length || promotion.products.length < LIMIT) {
      end = true;
    }
    state.data = {
      ...promotion,
      // products: state.data.products.concat(construct(promotion.products)),
      products: state.data.products.concat(promotion.products),
    };
  },
  UPDATE_PAGE() {
    page = ++page;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
